<template>
 
  <section
    id="screenshots"
    class="theme-bg screenshots"
    ref="screenshotsPosition"
  >
    <div class="animation-circle">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
            <h2 class="text-white">Chat Loop Screen Shot</h2>
            <img
              src="../../assets/images/white-line.png"
              alt="title-line"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="swiper-screenshots-container-1 swiper-container">
            <div class="swiper-wrapper">
              <swiper
                :modules="modules"
                :slides-per-view="3"
                :space-between="0"
                :centeredSlides="true"
                :navigation="true"
                :loop="true"
                :breakpoints="{
                  '100': {
                    slidesPerView: 1,
                    spaceBetween: 0,
                  },
                  '360': {
                    slidesPerView: 3,
                    spaceBetween: 0,
                  },
                  '640': {
                    slidesPerView: 5,
                    spaceBetween: 0,
                  },
                }"
              >
                <swiper-slide v-for="image in images" :key="image.id">
                  <div>
                    <img :src="image.imageUrl" alt="1" />
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
 
</template>

<script>
import SwiperCore, {
  Navigation,
  Parallax,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
SwiperCore.use(Navigation);

export default {
  name: "Screenshots",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
      images: [
        {
          id: 1,
          imageUrl: require("../../assets/images/ss/1.png"),
        },
        {
          id: 2,
          imageUrl: require("../../assets/images/ss/2.png"),
        },
        {
          id: 3,
          imageUrl: require("../../assets/images/ss/3.png"),
        },
        {
          id: 4,
          imageUrl: require("../../assets/images/ss/4.png"),
        },
        {
          id: 5,
          imageUrl: require("../../assets/images/ss/2.png"),
        },
        {
          id: 6,
          imageUrl: require("../../assets/images/ss/1.png"),
        },
      ],
    };
  },
  mounted() {
    let payload = {
      position: this.$refs["screenshotsPosition"].offsetTop,
      name: "screenshotsPosition",
    };
    this.$emit("windowPosition", payload);
  },
};
</script>
<style lang="scss" scoped>
.swiper-slide {
  img {
    transform: scale(0.8);
  }
}
.swiper-slide-active {
  img {
    transform: scale(0.9);
  }
}
</style>
